'use client';

import { ReactNode } from 'react';

import styles from './KeywordBadge.module.css';
type Props = {
  children: ReactNode;
};
export const KeywordBadge = ({ children }: Props) => {
  return <div className={styles.container}>{children}</div>;
};
